var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "trp-save-container" } }, [
    _c(
      "span",
      {
        staticStyle: { display: "none" },
        attrs: { id: "trp-translation-saved" }
      },
      [_vm._v(_vm._s(_vm.editorStrings.saved))]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "button-primary trp-save-string",
        attrs: {
          id: "trp-save",
          disabled: _vm.disabledSaveButton,
          type: "submit",
          title: _vm.editorStrings.save_title_attr
        },
        on: { click: _vm.save }
      },
      [_vm._v(_vm._s(_vm.saveButtonText))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }